import ColorfulResult from './colorful-result';
export default ColorfulResult;
